
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...blogPostsEN]",
      function () {
        return require("private-next-pages/[...blogPostsEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...blogPostsEN]"])
      });
    }
  